import React, { useEffect, useState } from 'react';
import * as currency from '@shopify/theme-currency'
import { Product } from '../types/product'
import shuffleArr from '../utils/shuffleArr';
import axios from 'axios';
import skinToneMap from '../utils/skinToneMap';


export function CartGrid() {

  const [randomizedVariantsArr, setRandomizedVariantsArr] = useState<any>([]);
  const [variantImages, setVariantImages] = useState<any>([]);
  const [skinToneArr, setSkinToneArr] = useState<any>([]);
  const selectors = {
    allProducts: '[data-all-products]',
  };
  const products: Product[] = JSON.parse(document.querySelector(selectors.allProducts).innerHTML);
  const skinToneMapArr = skinToneMap();
  const shuffledSkinToneArr = shuffleArr(skinToneMapArr);

  useEffect(() => {
    const variantArr = products.flatMap((product: any) => product.variants);
    const variantItemsArr = ["5x5-HDCLW-KSTR-NTR-18", "5x5-HDCLW-STR-NTR-18", "5x5-HDCLW-KSTR-NTR-18", "5x5-HDCLW-W-NTR-18", "5x5-HDCLW-STR-613-18", "5x5-HDCLW-VW-NTR-18"];
    const filteredArr = variantArr.filter((variant) => variantItemsArr.includes(variant.sku))
    let shuffledVariantsArr = [];
    for (var i = 0; i < variantItemsArr.length; i++) {
      for (var j = 0; j < filteredArr.length; j++) {
        if (filteredArr[j].sku == variantItemsArr[i]) {
          shuffledVariantsArr.push(filteredArr[j]);
        }
      }
    }

    const skinToneMapArr = [ { value: 'pearl', label: 'Jennifer' }, { value: 'ginger', label: 'Jalyn' }, { value: 'black-cherry', label: 'Ayo-Oluwa' }, { value: 'pearl', label: 'Jennifer' }, { value: 'black-cherry', label: 'Ayo-Oluwa' }, { value: 'ginger', label: 'Jalyn' }];
    const shuffledSkinToneArr = skinToneMapArr;
    setSkinToneArr(skinToneMapArr)

    setRandomizedVariantsArr(shuffledVariantsArr.slice(0, 4));
  }, [])

  useEffect(() => {
    async function getImage() {
      const variantItems = randomizedVariantsArr.map((variant, index) => {
        return axios.post('https://6eqmfkewa4.execute-api.us-east-1.amazonaws.com/image-provider-devel', {
          sku: variant.sku,
          model: skinToneArr[index].value,
        })
      });

      const response = await Promise.all(variantItems);
      setVariantImages(response);
    }

    if (randomizedVariantsArr.length) {
      getImage();
    }
  }, [randomizedVariantsArr])

  return (
    <div className="grid grid-cols-2 gap-[20px]">
      {
        randomizedVariantsArr.map((product, index) => {
          return <a className="block group hover:drop-shadow-card bg-white border border-gray-400" href={`/products/${product.name.substring(0, product.name.indexOf(' -')).replace(/\s/g, '-')}?variant=${product.id}&shade=${variantImages[index]?.data.model}`}>
              <video className="object-cover" playsInline autoPlay loop muted data-carousel-video>
                <source src={variantImages[index]?.data.video} type="video/mp4" />
              </video>
              <div className="p-5 group-hover:opacity-100">
                <div className="flex flex-col items-center text-center">
                  <p className="text-xs sm:text-base-m apex:text-xl">{product.name.substring(0, product.name.indexOf('-'))}</p>
                  <p className="text-base sm:text-base-m apex:text-xl font-semibold mt-2">{currency.formatMoney(product.price, '${{amount_no_decimals}}')}</p>
                </div>
                <button className="font-semibold uppercase bg-black text-white block text-center text-xs sm:text-btn-sm-d leading-none p-2.5 mt-5 w-full">
                  get the look
                </button>
              </div>
            </a>
        })
      }
    </div>
  );
}
